import Text from "common/Typography/Text";
import styled from "styled-components";
import { disabledStyle } from "common/Buttons/styles";
import { typography } from "@shared/common/Themes/typography";
import { CardActionButtonProps } from "@shared/common/CardsList/types";

const CardActionButton = ({
  icon,
  text,
  onClick,
  size,
  bordered,
  horizontal,
  invalid,
}: CardActionButtonProps) => {
  const handleClick = (e: any) => {
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <Wrapper
      onClick={handleClick}
      $bordered={bordered}
      $horizontal={horizontal}
      $invalid={invalid}
    >
      <Text
        as="div"
        type="secondary"
        $size={size === "m" ? typography.fontSizes.L : typography.fontSizes.XL}
        style={{ marginRight: horizontal ? 8 : 0 }}
      >
        {icon}
      </Text>
      <Text
        as="div"
        type="secondary"
        $size={size === "m" ? typography.fontSizes.XS : typography.fontSizes.S}
      >
        {text}
      </Text>
    </Wrapper>
  );
};

export default CardActionButton;

const Wrapper = styled.div<{
  $bordered?: boolean;
  $horizontal?: boolean;
  $invalid?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  border-radius: 8px;
  flex-flow: ${(p) => (p.$horizontal ? "row" : "column")};
  transition: border 0.35s ease-in-out;
  ${(p) =>
    p.$bordered &&
    `
    border: ${p.theme.borders.medium};
    padding: 4px 12px;
  `};
  ${(p) =>
    p.onClick &&
    `
    cursor: pointer;
    &:hover {
      ${Text} {
        color: ${p.theme.colors.primaryBlue};
      } 
      border-color: ${p.theme.colors.primaryBlue};
    } 
  `}
  ${(p) => p.$invalid && disabledStyle}
`;
